import * as XLSX from "xlsx";
import { Download } from "lucide-react";

const TemplateImportEvolution = ({ questions, selectedYear, niveau, selectedMatiere }) => {

  const handleDownload = () => {
    if (!questions || questions.length === 0) {
      alert("Aucune question disponible pour générer le fichier.");
      return;
    }


    // Créer un classeur Excel
    const workbook = XLSX.utils.book_new();

    if (selectedMatiere === 'maths') {
      // ===== MATHS =====
      // Préparer les données pour la feuille "Automatismes"
      const automatismesData = [
        [`${niveau.toUpperCase()} - AUTOMATISMES`],
        ["Question", "ID", "Nom label", `% réussite ${selectedYear}`],
        ...questions
          .filter((q) => q.type_label === "Automatisme")
          .map((q) => [
            q.question_num,
            q.id,
            q.nom_label || q.type_label || q.nom || "",
            "",
          ]),
      ];

      const worksheetAutomatismes = XLSX.utils.aoa_to_sheet(automatismesData);
      XLSX.utils.book_append_sheet(workbook, worksheetAutomatismes, "Automatismes");

      // Ajouter la feuille "Résolution de problèmes" seulement pour 6ème et 4ème
      if (niveau[0] === "6" || niveau[0] === "4") {
        const resolutionProblemesData = [
          [`${niveau.toUpperCase()} - RÉSOLUTION DE PROBLÈMES`],
          ["Question", "ID", "Nom label", `% réussite ${selectedYear}`],
          ...questions
            .filter((q) => q.type_label === "Résolution de problèmes")
            .map((q) => [
              q.question_num,
              q.id,
              q.nom_label || q.type_label || q.nom || "",
              "",
            ]),
        ];

        const worksheetResolutionProblemes = XLSX.utils.aoa_to_sheet(resolutionProblemesData);
        XLSX.utils.book_append_sheet(workbook, worksheetResolutionProblemes, "Résolution de problèmes");
      }

    } else if (selectedMatiere === 'français') {
      // ===== FRANÇAIS =====

      if (niveau[0] === "5") {
        // Français 5ème : Compétences langagières uniquement
        const competencesData = [
          [`${niveau.toUpperCase()} - COMPÉTENCES LANGAGIÈRES`],
          ["Question", "ID", "Nom label", `% réussite ${selectedYear}`],
          ...questions
            .filter((q) => q.type_label === "Compétences langagières et linguistiques")
            .map((q) => [
              q.question_num,
              q.id,
              q.nom_label || q.type_label || q.nom || "",
              "",
            ]),
        ];

        const worksheetCompetences = XLSX.utils.aoa_to_sheet(competencesData);
        XLSX.utils.book_append_sheet(workbook, worksheetCompetences, "Compétences langagières");

      } else {
        // Français 6ème et 4ème : Lexique + Compréhension écrite

        // Feuille Lexique
        const lexiqueData = [
          [`${niveau.toUpperCase()} - LEXIQUE`],
          ["Question", "ID", "Nom label", `% réussite ${selectedYear}`],
          ...questions
            .filter((q) => q.type_label === "Lexique")
            .map((q) => [
              q.question_num,
              q.id,
              q.nom_label || q.type_label || q.nom || "",
              "",
            ]),
        ];

        const worksheetLexique = XLSX.utils.aoa_to_sheet(lexiqueData);
        XLSX.utils.book_append_sheet(workbook, worksheetLexique, "Lexique");

        // Feuille Compréhension écrite (regroupe tous les textes)
        const comprehensionData = [
          [`${niveau.toUpperCase()} - COMPRÉHENSION DE L'ÉCRIT`],
          ["Question", "ID", "Nom label", `% réussite ${selectedYear}`],
          ...questions
            .filter((q) => q.type_label?.startsWith("Compréhension de l'écrit"))
            .map((q) => [
              q.question_num,
              q.id,
              q.nom_label || q.type_label || q.nom || "",
              "",
            ]),
        ];

        const worksheetComprehension = XLSX.utils.aoa_to_sheet(comprehensionData);
        XLSX.utils.book_append_sheet(workbook, worksheetComprehension, "Compréhension écrite");
      }
    }

    // Générer et télécharger le fichier Excel
    const matiereLabel = selectedMatiere === 'maths' ? 'Maths' : 'Francais';
    const fileName = `${niveau}_${matiereLabel}_TemplateImportEvolution_${selectedYear}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  return (
    <div className="text-center">
      <button
        onClick={handleDownload}
        className="inline-flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700 transition-colors group"
      >
        <Download size={16} className="group-hover:-translate-y-0.5 transition-transform" />
        <span>Télécharger le modèle Excel</span>
      </button>
    </div>
  );
};

export default TemplateImportEvolution;
